import React from 'react';
import { smoothScroll } from '../utils/scroll';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="home" className="hero">
      <div>
        <span className="badge">Giochi da tavolo, videogame, GdR, LARP, coding, cosplay</span>
        <h1>Gioco per Tutti è una community che usa il gioco per unire le persone.</h1>
        <p className="lead">
          Siamo un’associazione culturale senza scopo di lucro che crea eventi, serate di gioco, tornei, jam di sviluppo e attività creative aperte a tutti. Crediamo nel gioco come spazio di incontro, sperimentazione e condivisione: che tu ami tirare dadi, costruire mondi, sviluppare prototipi o semplicemente giocare in compagnia, qui trovi persone con cui farlo davvero.
        </p>
        {/* <div className="hero-actions">
          <a className="cta" href="#partecipa" onClick={(e) => { e.preventDefault(); smoothScroll('#partecipa'); }}>
            Partecipa ora
          </a>
          <a className="cta secondary" href="#attivita" onClick={(e) => { e.preventDefault(); smoothScroll('#attivita'); }}>
            Scopri le attività
          </a>
        </div> */}
        {/* <div className="stats">
          <div className="stat">
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>👥</div>
            <strong>800+</strong>
            persone nella community in crescita costante.
          </div>
          <div className="stat">
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>🎯</div>
            <strong>12</strong>
            format diversi: boardgame night, D&D, LAN, workshop, LARP.
          </div>
          <div className="stat">
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>📅</div>
            <strong>50</strong>
            eventi all'anno gestiti da volontari.
          </div>
        </div> */}
      </div>
      <div className="panel">
        <h3>Cosa facciamo</h3>
        <ul>
          <li><strong>Eventi e tornei:</strong>organizziamo grandi eventi, serate di gioco e tornei aperti alla community</li>
          <li><strong>Gioco di Ruolo dal Vivo:</strong> manifestazioni e progetti per la valorizzazione del territorio</li>
          <li><strong>Progetti educativi:</strong> interventi nelle scuole contro bullismo e dispersione scolastica tramite la gamification</li>
          <li><strong>Inclusione e creatività:</strong> laboratori accessibili e attività creative aperte a tutti</li>
          <li><strong>Sport della Mente ed eSports:</strong> iniziative per il benessere cognitivo e sociale</li>
          <li><strong>Memoria ludica e retrogaming:</strong> tutela e valorizzazione della cultura del gioco e spazi di socializzazione</li>
        </ul>
        {/* <div className="hero-actions">
          <a className="cta" href="#calendario" onClick={(e) => { e.preventDefault(); smoothScroll('#calendario'); }}>
            Vai al calendario
          </a>
          <a className="cta secondary" href="#volontari" onClick={(e) => { e.preventDefault(); smoothScroll('#volontari'); }}>
            Diventa volontario
          </a>
        </div> */}
      </div>
    </section>
  );
};

export default Hero;



